import { MOMENT } from '@/utils/const/activity/lvs';
import { Element } from 'react-scroll';
import styles from '../style.module.scss';
import { LVSH1 } from '../../widget';
import FadeIn from '@/components/commonComponents/fadeIn';
import { WebPNextImage } from '@/components/WebPImage';
import { useUserAgentInfo } from '@/context/user-agent';

const Moment = (props: typeof MOMENT) => {
  const { title, image } = props;
  const { isMobile } = useUserAgentInfo();
  if (isMobile) {
    return (
      <div className={styles['concise']}>更多大会精彩内容请前往PC端查看...</div>
    );
  }
  return (
    <Element name={title.main} key={title.main}>
      <div className={styles['activity-wrapper']}>
        <LVSH1 title={title.main} subTitle={title.vice} />
        <FadeIn>
          <div className={styles['moment']}>
            <WebPNextImage src={image} layout="fill" />
          </div>
        </FadeIn>
      </div>
    </Element>
  );
};

export default Moment;
